import React,{Component} from 'react';
import AddContractor from './AddContractor';
export default class ContractorSetting extends Component{
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        return (
            <AddContractor {...this.props}/>
        )
    }
}